/* eslint-disable react/no-unescaped-entities */
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";
import AlphabetFilter from "../components/AlphabetFilter";
import "../styles/MyGames.css";

function MyGames() {
  const [games, setGames] = useState([]);
  const [filteredGames, setFilteredGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch data from Supabase
  useEffect(() => {
    const fetchGames = async () => {
      try {
        const { data, error } = await supabase
          .from("my_steam_games")
          .select("*")
          .order("GAME_NAME", { ascending: true });

        if (error) throw error;

        setGames(data);
        setFilteredGames(data); // Show all games initially
      } catch (err) {
        console.error("Error fetching games:", err);
        setError(
          "An error occurred while fetching games. Please try again later."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchGames();
  }, []);

  // Filter games based on selected letter
  const handleFilterChange = (letter) => {
    if (letter === "all") {
      setFilteredGames(games);
    } else {
      const filtered = games.filter(
        (game) =>
          game.GAME_NAME && game.GAME_NAME.toUpperCase().startsWith(letter)
      );
      setFilteredGames(filtered);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) {
      return "Invalid Date";
    }
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  };

  return (
    <div>
      <div>
        <section className="top-section">
          <h1 className="title">Welcome to my Steam Game Library</h1>
          <hr></hr>
          <p>
            This should be an up-to-date list of all of the games that I have on
            Steam, how long I've played them for, and how close I am to
            perfecting each game.
          </p>
          <hr></hr>
          <p>
            I have a "problem" where I go for 100% achievements in every game
            that I play, and, with this list, you can see me slowly progress
            through. Clicking on a tile will eventually link you to a "review"
            type page where I'm going to log my thoughts on each game. It may or
            may not include pictures or screenshots.
          </p>
        </section>
      </div>
      <AlphabetFilter onFilterChange={handleFilterChange} />
      {loading ? (
        <p>Loading games...</p>
      ) : error ? (
        <p>Error: {error}</p>
      ) : (
        <div className="game-list">
          {filteredGames && filteredGames.length > 0 ? (
            filteredGames.map((game) => {
              if (game.APP_ID && game.GAME_NAME) {
                return (
                  <Link
                    to={`/mygames/${encodeURIComponent(game.APP_ID)}`}
                    key={game.APP_ID}
                    className="game-card"
                    style={{
                      backgroundImage:
                        "url(https://shared.akamai.steamstatic.com/store_item_assets/steam/apps/" +
                        game.APP_ID +
                        "/header.jpg)",
                    }}
                  >
                    {<h2>{game.GAME_NAME}</h2>}
                    <span>
                      <p style={{ float: "left" }}>
                        Hours Played: {game.HOURS_PLAYED.toFixed(2)}
                      </p>
                      <p style={{ float: "right" }}>
                        Last Played:{" "}
                        {formatDate(game.LAST_PLAYED) === "12-31-1969"
                          ? "Never"
                          : formatDate(game.LAST_PLAYED)}
                      </p>
                    </span>
                    <span>
                      <p style={{ float: "left" }}>
                        My Achievements: {game.USER_ACH}
                      </p>
                      <p style={{ float: "right" }}>
                        Total Game Achievements: {game.GAME_ACH_TOTAL}
                      </p>
                    </span>
                    {game.GAME_ACH_TOTAL !== 0 && (
                      <p>
                        % Complete:{" "}
                        {((game.USER_ACH / game.GAME_ACH_TOTAL) * 100).toFixed(
                          2
                        )}
                      </p>
                    )}
                  </Link>
                );
              } else {
                console.warn(
                  "Game data is missing 'APP_ID' or 'GAME_NAME':",
                  game
                );
                return null;
              }
            })
          ) : (
            <p>No games available</p>
          )}
        </div>
      )}
    </div>
  );
}

export default MyGames;
